import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { Box } from '@xceedsrl/jukebox';
import SectionTitle from './SectionTitle';
import TicketBuyer from './TicketBuyer';
import { useTranslation } from '../i18n/I18nProvider';
function TicketHolders(_ref) {
  var holderFields = _ref.holderFields,
    attendesForPurchase = _ref.attendesForPurchase,
    customTitleColor = _ref.customTitleColor,
    formik = _ref.formik;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function createSingleForm(fields, id) {
    var normalizedHolderFields = useMemo(function () {
      return fields.map(function (field) {
        delete field.id;
        return _objectSpread(_objectSpread({}, field), {}, {
          slug: id + "_" + field.slug,
          displayName: t(field.slug) === field.slug ? field.name : t(field.slug)
        });
      });
    }, [fields, t]);
    return React.createElement(Box, {
      key: id,
      mb: 3
    }, React.createElement(SectionTitle, {
      color: customTitleColor
    }, t('ticketHolder', {
      id: id
    })), React.createElement(TicketBuyer, {
      formik: formik,
      fields: normalizedHolderFields
    }));
  }
  return Array(attendesForPurchase).fill().map(function (_, i) {
    return createSingleForm(holderFields, i + 1);
  });
}
export default React.memo(TicketHolders);